import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import {isLoading} from "Modules/Loading"

const initialState = Immutable.Map({}).set('Search', new Immutable.List([])).set('Response', new Immutable.Map({})).set('Get', new Immutable.Map({}))

/* Types */

export const ACTION_NEW_VARIABLE = 'ACTION_NEW_VARIABLE'

export const ACTION_SEARCH_VARIABLE = 'ACTION_SEARCH_VARIABLE'

export const ACTION_GET_VARIABLE = 'ACTION_GET_VARIABLE'

export const ACTION_DELETE_VARIABLE = 'ACTION_DELETE_VARIABLE'

export const ACTION_UPDATE_VARIABLE = 'ACTION_UPDATE_VARIABLE'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case ACTION_NEW_VARIABLE:
			return state.set('Response', new Immutable.Map(action.Obj))
		case ACTION_SEARCH_VARIABLE:
			return state.set('Search', new Immutable.List(action.Obj))
		case ACTION_GET_VARIABLE:
			return state.set('Get', new Immutable.Map(action.Obj))
		case ACTION_DELETE_VARIABLE:
			return state.set('Response', new Immutable.Map(action.Obj))
		case ACTION_UPDATE_VARIABLE:
			return state.set('Response', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const addVariable = (form) => {

	let data = Object.assign({}, form)
	data.preguntasValoracion = Utils.getListPropsOmit(data.preguntasValoracion,  ['custom', 'id', 'puntuacionMaxima', 'preguntaValoracionItem'])
	data.rangos = Utils.getListPropsOmit(data.rangos, ['id', 'tmp'])

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/newVariable',
			method: "POST",
			data: {...data},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_NEW_VARIABLE, Obj: response.data })
			dispatch(createModal(Utils.successMessage()))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const searchVariable = (form) => {

	Utils.clearNullAndEmpty(form)

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: Object.keys(form).length == 0 ? 'api/searchVariable' : 'api/searchParamVariable',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_SEARCH_VARIABLE, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getVariable = (id) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getVariable',
			method: "POST",
			data: { id },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch({ type: ACTION_GET_VARIABLE, Obj: response.data})
			dispatch(isLoading(false))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const deleteVariable = () => {
	return (dispatch) => {
		return dispatch({ type: ACTION_DELETE_VARIABLE, Obj: {code: '', message: ''} })
	}
}

export const updateVariable = (form) => {

	let data = Object.assign({}, form)
	data.preguntasValoracion = Utils.getListPropsOmit(data.preguntasValoracion, ['custom', 'id', 'preguntaValoracionItem', 'puntuacionMaxima'])
	data.preguntasValoracion = Utils.unionArray(data.preguntasValoracion, data.preguntasValoracionRemove)

	data.rangos = Utils.getListPropsOmit(data.rangos, ['id', 'tmp'])
	data.rangos = Utils.unionArray(data.rangos, data.rangosRemove)

	return (dispatch) => {

		dispatch(isLoading(true))
		dispatch({ type: ACTION_GET_VARIABLE, Obj: {} })

		return new ClientHttpRequest({
			service: 'api/updateVariable',
			method: "POST",
			data: {...data},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_UPDATE_VARIABLE, Obj: response.data })
			dispatch(createModal(Utils.successMessage()))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const exportPDFVariable = (form) => {
	return (dispatch) => {
		dispatch(isLoading(true))
		return new ClientHttpRequest({
			service: 'api/exportPDFVariable',
			method: 'POST',
			data: {...form},
			responseType: 'arraybuffer',
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request()
		.then(response => {
			dispatch(isLoading(false))
			let fileURL = `${process.env.baseURL}/reporte-configuracion-variables.pdf`
			window.open(fileURL)
		})
		.catch(error => {
			dispatch(isLoading(false))
			throw error
		})
	}
}

export const clearVariable = () => {
	return (dispatch) => {
		dispatch({ type: ACTION_GET_VARIABLE, Obj: {} })
		dispatch({ type: ACTION_SEARCH_VARIABLE, Obj: []})
	}
}



// WEBPACK FOOTER //
// ./src/modules/Configurations/TypeEvaluation/Variable.js